import { RegisteredComponent } from "@builder.io/sdk-react";

export const internalSearchBannerBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "InternalSearchBannerBlock",
  friendlyName: "Internal Search Banner",
  noWrap: true,
  canHaveChildren: true,
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "variant",
      type: "enum",
      enum: ["swdc", "support"],
      required: true,
      defaultValue: "swdc",
    },
  ],
};
